var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.518 6.006v.461m0 11.796v-8.94m10.963 8.94V12.92a3.905 3.905 0 0 0-3.899-3.899 3.906 3.906 0 0 0-3.906 3.9m0 0v5.34m0-5.34V9.323M6.385 22h11.23A4.385 4.385 0 0 0 22 17.615V6.385A4.385 4.385 0 0 0 17.615 2H6.385A4.385 4.385 0 0 0 2 6.385v11.23A4.385 4.385 0 0 0 6.385 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLine);
export default __webpack_public_path__ + "static/media/linkedin_line.4b5721c8fd9fec5e4e4575bcb55a694d.svg";
export { ForwardRef as ReactComponent };